import palette from 'theme/palette';
import { createStyles, makeStyles } from '@material-ui/styles';

interface priceSliderStyleProps {
  localPrice: string;
  left: number;
  leftb: number;
}

const style = () =>
  createStyles({
    slider: {
      width: '100%',
      position: 'relative',
      appearance: 'none',
      background: (props: priceSliderStyleProps) =>
        'linear-gradient(90deg, #30EA64 ' +
        props.left +
        '%, #ECECEC ' +
        props.left +
        '%, rgba(236, 236, 236, 0) 100%)',
      outline: 'none',
      height: '18px',
      margin: '5px 0 10px 0',
      borderRadius: '5px',
      '&::-webkit-slider-thumb': {
        appearance: 'none',
        height: '36px',
        width: '80px',
        background: palette.background.box,
        borderRadius: '10px',
        boxShadow: palette.shadows.boxShadow
      },
      '&::before': {
        content: (props: priceSliderStyleProps) =>
          '"' + props.localPrice + ' € max"',
        fontWeight: 600,
        pointerEvents: 'none',
        fontSize: '13px',
        height: '10px',
        width: '80px',
        position: 'absolute',
        top: '0',
        '@media (max-width: 768px)': {
          left: (props: priceSliderStyleProps) =>
            'calc( ' +
            props.left +
            '% - (30px * (' +
            props.left +
            ' / 50)) + 5px)'
        },
        left: (props: priceSliderStyleProps) => props.leftb + '%'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
